/* eslint-disable @typescript-eslint/no-explicit-any */
import { postModel } from '../../../services/api.service';

/**
 * Save new public reservation
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
export const createPublicReservation = async (payload): Promise<any> => {
    const urlModel = `reservations`;

    const data = await postModel(urlModel)(payload);
    return data;
};
